export default {
  data() {
    return {
      example_file_name: "john_doe_breakfast_show_01-01-2019.mp3",
    };
  },
  computed: {
    sanitised_file_name() {
      const last_file_name_part = this.example_file_name.split('.').pop();
      // Remove the file extension from the file name
      let sanitised_file_name = this.example_file_name.replace(`.${last_file_name_part}`, '');
      // Replace none a-z characters
      sanitised_file_name = sanitised_file_name.replace(/[^A-Za-z]+/g, " ");
      // Replace leading and trailing spaces
      sanitised_file_name = sanitised_file_name.trim();
      // Replace multiple spaces with single space
      sanitised_file_name = sanitised_file_name.replace(/\s\s+/g, ' ');

      return sanitised_file_name.replace(/[^A-Za-z]+/g, " ");
    },
  },
  methods: {
    convertSecondsToDaysHoursMinutes(seconds) {
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor(((seconds % 86400) % 3600) / 60);
      return {
        days: days,
        hours: hours,
        minutes: minutes,
      };
    },
    convertPublishDataToSeconds(publish_object) {
      let seconds = 0;
      seconds += publish_object.days * 86400;
      seconds += publish_object.hours * 3600;
      seconds += publish_object.minutes * 60;
      return seconds;
    },
  },
};
